module.exports = __webpack_public_path__ + "apple-icon-76x76.6cb5c19d.png";